import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import ApproverModal from "./ApproverModal";
import { SERVER_BASE } from "../config/server";
import apiClient from "../utils/apiClient";
import Swal from "sweetalert2";

const ItemConversionPreview = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const rowData = location?.state?.rowData;
   const [personOptions, setPersonOptions] = useState([]);
   const token = localStorage.getItem('token')
   const [profileDetails, setProfileDetails] = useState(null);
   const centerCode = localStorage.getItem('code')
   const email = localStorage.getItem('email')
   const name = localStorage.getItem('name');
   const badgeId = localStorage.getItem('badgeId');
   const pin = localStorage.getItem('pin');
   const [selectedChallanId, setSelectedChallanId] = useState(null);
   const [modalShow, setModalShow] = useState(false);
   const [data, setData] = useState([])
   const [searchParams] = useSearchParams();
   const personId = searchParams.get('personId')
  
     const type = searchParams.get('type');
     let id = type == "conversion" ? searchParams.get('conversionId') : rowData

     const fetchConversions = async () => {
      try {
          const response = await apiClient.get(`${SERVER_BASE}/get-specific-item-conversions/${id}`, {
              headers: { Authorization: `Bearer ${token}` },
          });

          setData(response.data[0]);
      } catch (error) {
          console.error("Error fetching conversions:", error);
      }
  };

  useEffect(() => {
      fetchConversions();
  }, []);
    useEffect(() => {
       fetchPersons();
       fetchProfileDetails();
     }, []);
     const closeModal = () => {
       setModalShow(false); // Close the modal
     };
     
     const fetchProfileDetails = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/getProfile`, { params: { email } });
        setProfileDetails(response.data?.[0] || null); // Assume the first row contains the profile data
      } catch (err) {
        console.error('Error fetching profile details:', err);
        setProfileDetails(null);
  
      }
    };
  const handleSendForApproval = (rowData) => {

    if (!token) {
      window.location.href = "/";
    } else {
      setSelectedChallanId(rowData);
      setModalShow(true); // Show modal
    }
  };
  useEffect(() => {
    if (!token) {
      navigate(
        `/?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}&type=approveConversion`
      );


      return;
    }
  }, []);
   const fetchPersons = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getApprovers`, { // Assuming there's an endpoint to fetch persons
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        }
      });
      setPersonOptions(
        response.data.map((person) => ({
          value: person.id,
          label: `${person.firstName} ${person.lastName} - ${person.contactNo}`, // Assuming 'firstName' and 'lastName' are available
          mobileNo: person.contactNo,
          badgeId: person.badgeId
        }))
      );

    } catch (error) {
      console.error('Error fetching persons for approval:', error);
    }
  };
  const handleApprove = () => {
    // SweetAlert2 for PIN input

    Swal.fire({
      title: 'Enter your PIN',
      input: 'password',
      inputPlaceholder: 'Enter your PIN',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Submit',
      inputValidator: (value) => {
        if (!value) {
          return 'Please enter your PIN.';
        }
        if (value !== pin) {
          return 'Invalid PIN. Please try again.';
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Proceed with the approval if PIN matches
        const approvedBy = name;
        const approvedByBadge = badgeId;

        // Send the approval request to the backend
        apiClient.post(`${SERVER_BASE}/approveConversion`, {
          approvedBy,
          approvedByBadge,
        data:data,
        id:rowData
        })
          .then(response => {
            Swal.fire({
              icon: 'success',
              text: 'The voucher has been verified successfully.',
              position:'top-end',
              toast:true,
              showConfirmButton:false,
              timer:3000,
              timerProgressBar:true
            }).then(() => {
              window.location.reload();
            });
          })
          .catch(err => {
            Swal.fire({
              toast: true,
              icon: 'error',
              title: 'Error',
              text: `Can't Approve: ${err.response?.data?.message || err.message}`,
              confirmButtonText: 'OK',
              width: '600px',   // ✅ increase width
            });
          });
      }
      // fetchDraftData();
    });
  };
  const handleModalSubmit = async (personId) => {

    const selectedPerson = personOptions.find(
      (person) => String(person.value) == String(personId)
    );
    const mobileNo = selectedPerson?.mobileNo;

    try {
      // API call to send for approval
      await apiClient.post(
        `${SERVER_BASE}/sendForApproval/${rowData}`,
        { personId, type: 'Conversion' },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const baseLink = `https://rs.iosystem.in/ItemConversionPreview?id=${rowData}`;
      const fullLink = `${baseLink}&conversionId=${rowData}&personId=${personId}&type=conversion`;
      const whatsappLink = `https://wa.me/+91${mobileNo}?text=${encodeURIComponent(
        `Check this Item Conversion draft: ${fullLink}`
      )}`;
      window.open(whatsappLink, "_blank");

      setModalShow(false); // Close modal after successful submission
    } catch (error) {
      console.error("Error sending for approval:", error);
      setModalShow(false); // Close modal on error
    }
  };
  if (!rowData && !id) {
    return (
      <div className="text-center mt-5">
        <h6 className="text-muted">No preview data available</h6>
        <button
          className="btn btn-secondary btn-sm mt-3"
          onClick={() => navigate(-1)}
        >
          <FontAwesomeIcon icon={faChevronCircleLeft} /> Back
        </button>
      </div>
    );
  }

  return (
    <div className="formcontainer mt-5" style={{ maxWidth: "1050px" }}>
      {/* Header */}
      <div className="d-flex align-items-center justify-content-between mb-3">
  {/* Left: Back button */}
  <div>
    <button
      className="btn btn-outline-secondary btn-sm"
      onClick={() => navigate("../dashboard/ItemConversionList")}
    >
      <FontAwesomeIcon icon={faChevronCircleLeft} /> Back
    </button>
  </div>

  {/* Center: Header */}
  <h6 className="m-0 fw-bold text-uppercase text-secondary text-center flex-grow-1">
    Item Conversion Preview
  </h6>

  {/* Right: Action Buttons */}
  <div>
    {profileDetails &&
      String(profileDetails.id) !== String(personId) &&
      String(profileDetails.id) !== String(data?.authorizedPersonId) &&
      data.status !== "Approved" &&
      data.status !== "Cancelled" && (
        <button
          className="btn btn-secondary btn-sm no-print me-2"
          onClick={() => handleSendForApproval(rowData)}
        >
          <FontAwesomeIcon icon={faPaperPlane} /> Send for Verification
        </button>
      )}

    {profileDetails &&
      (String(profileDetails.id) === String(personId) ||
        String(profileDetails.id) === String(data?.authorizedPersonId)) &&
      data.status !== "Approved" &&
      data.status !== "Cancelled" && (
        <button className="btn btn-success btn-sm" onClick={handleApprove}>
          Approve
        </button>
      )}
  </div>
</div>


      {/* Basic Info */}
      <div className="card shadow-sm mb-3 border-0" style={{ fontSize: "14px" }}>
        <div className="card-body py-2 px-3">
          <div className="row gy-1">
            <div className="col-md-3">
              <strong>Date & Time:</strong>{" "}
              {data.createdAt
                ? moment(data.createdAt).format("DD-MMM-YY hh:mm A")
                : "-"}
            </div>
            <div className="col-md-3">
              <strong>Department:</strong> {data.department || "-"}
            </div>
            <div className="col-md-3">
              <strong>Location:</strong> {data.location || "-"}
            </div>
            <div className="col-md-3">
              <strong>Created By:</strong>{" "}
              {data.createdByName || data.createdBy || "-"}
            </div>
          </div>
        </div>
      </div>

      {/* Tables */}
      <div className="row g-3">
        {/* From Items */}
        <div className="col-md-6">
          <div className="card shadow-sm border-0">
            <div
              className="card-header fw-semibold py-1 px-2 bg-light text-danger"
              style={{ fontSize: "14px" }}
            >
              Consumption (From Items)
            </div>
            <div className="card-body p-2">
              <table
                className="table table-sm table-bordered mb-0 text-center align-middle"
                style={{ fontSize: "13px" }}
              >
                <thead className="table-light">
                  <tr>
                    <th>Item</th>
                    <th>Qty</th>
                    <th>UOM</th>
                  </tr>
                </thead>
                <tbody>
                  {data.fromItems?.length > 0 ? (
                    data.fromItems.map((f, i) => (
                      <tr key={i}>
                        <td className="text-start">
                          {f.itemName || f.fromItemName}
                        </td>
                        <td>{f.quantity || f.fromQuantity}</td>
                        <td>{f.uom || f.fromUom}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-muted">
                        No data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* To Items */}
        <div className="col-md-6">
          <div className="card shadow-sm border-0">
            <div
              className="card-header fw-semibold py-1 px-2 bg-light text-success"
              style={{ fontSize: "14px" }}
            >
              Production (To Items)
            </div>
            <div className="card-body p-2">
              <table
                className="table table-sm table-bordered mb-0 text-center align-middle"
                style={{ fontSize: "13px" }}
              >
                <thead className="table-light">
                  <tr>
                    <th>Item</th>
                    <th>Qty</th>
                    <th>UOM</th>
                  </tr>
                </thead>
                <tbody>
                  {data.toItems?.length > 0 ? (
                    data.toItems.map((t, i) => (
                      <tr key={i}>
                        <td className="text-start">
                          {t.itemName || t.toItemName}
                        </td>
                        <td>{t.quantity || t.toQuantity}</td>
                        <td>{t.uom || t.toUom}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-muted">
                        No data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <ApproverModal
        show={modalShow}
        title="Send for Approval"
        options={personOptions}
        close={closeModal} // Pass close function
        onSubmit={handleModalSubmit}

      />
    </div>
  );
};

export default ItemConversionPreview;
